import Hero from 'assets/images/sgp/hero/sgp-general-hero-optimized.webp';
import garage from 'assets/images/psp/garage.svg';
import drive from 'assets/images/sgp/10x20/drive.svg';
import businessready from 'assets/images/sgp/10x20/businessready.svg';
import households from 'assets/images/sgp/10x20/households.svg';
import multiplevehicle from 'assets/images/sgp/10x20/multiplevehicle.svg';
import electricity from 'assets/images/sgp/10x15/electricity.svg';
import map from 'assets/images/sgp/10x20/map.svg';
import altContentImage from 'assets/images/sgp/5x5/alt-content-image.webp';
import postCovers from 'assets/images/sgp/10x30/largest-unit-size.webp';
import largestStorage from 'assets/images/sgp/10x20/storageunit.webp';
import shutterStock from 'assets/images/sgp/5x5/storage-unit-size.webp';
import carStorage from 'assets/images/sgp/10x20/interior-car-storage.jpg';
import { pageTypes } from 'config/pageTypes';
import twoColumnTableImage from 'assets/images/sgp/twoColumnTable.svg';
import threeColumnTableImage from 'assets/images/sgp/threeColumnTable.svg';

const alternateContentData1 = {
	title: 'Looking for a Large Storage Unit?',
	description:
		'If you’re here, chances are that you’re looking for a large storage unit to give your stuff a new home. Lucky for you, SpareFoot has a variety of storage unit sizes to suit your large storage needs. Here’s your Goldilocks storage unit menu to help you find the best storage space: ',
	additionalProps: {
		paragraph: {
			color: 'black',
		},
	},
	content: [
		{
			title: '',
			image: altContentImage,
			description:
				'**Medium Units:** 10x10, 10x15, 5x15 \n\n **Small Units:** 5x5, 5x10, Mini storage, Storage lockers \n\n **Large Units:** 10x20 (*you are here*),  10x25, 10x30 \n',
		},
	],
};
const threePanelBlock = {
	props: {
		title: 'Why a 10x20 Storage Unit Is Your Best Big-Space Solution',
		description: '',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: households,
				description:
					'### Spacious Enough for Entire Households \n\n With 200 square feet of floor space, you can store the complete contents of a 3-4 bedroom home. Perfect for major life transitions, relocations, or long-term downsizing situations.',
			},
			{
				image: multiplevehicle,
				description:
					'### Multiple Vehicle Storage \n\n Wondering, *"Can you fit a car in a 10x20 storage unit?"* The answer is yes. Store multiple vehicles, large RVs, boats, or combine vehicle storage with household items in one convenient location.',
			},
			{
				image: businessready,
				description:
					'### Business-Ready Storage Capacity \n\n Growing businesses love these units for inventory, equipment, and supplies. The generous space accommodates everything from retail stock to construction tools and office furniture.',
			},
		],
	},
};
const threePanelBlock1 = {
	props: {
		title: 'How Much Furniture Can Fit in a 10x20 Storage Unit?',
		description: '',
		type: 'three-panel',
		pageType: 'SGP',
		content: [
			{
				image: households,
				description:
					'### Complete Household Contents \n - 3-4 bedroom home furnishings \n - Multiple living room sets \n -  Full kitchen appliances (refrigerator, washer, dryer, dishwasher) \n - Several bedroom sets with mattresses \n - Dining room furniture and china cabinets \n - Home office equipment \n - 60-80+ boxes of personal belongings',
			},
			{
				image: multiplevehicle,
				description:
					'### Vehicle & Recreation Storage \n - Two standard cars \n - [Large RV or motorhome](https://www.sparefoot.com/blog/rv-storage-size-guide) \n - Boat with trailer \n - Multiple motorcycles or ATVs \n - Workshop tools and equipment',
			},
			{
				image: businessready,
				description:
					'### Business Applications \n - Retail inventory for small to medium businesses \n - Office furniture for entire small business \n - Construction equipment and materials \n - Seasonal merchandise displays',
			},
		],
	},
};
const twoPanelBlock = {
	props: {
		title: 'Popular Amenities for Your 10x20 Storage Unit',
		suffix: 'Make the most of your 10x20 unit with these amenities, maximizing protection and convenience.',
		type: 'two-panel',
		content: [
			{
				image: garage,
				description:
					'### Climate Control When You Need It \n\n Many facilities offer 10x20 [climate controlled options](https://www.sparefoot.com/blog/do-you-need-climate-control-in-your-storage-unit), protecting sensitive items from temperature and humidity fluctuations. Essential for electronics, documents, and valuable furnishings.',
			},
			{
				image: drive,
				description:
					'### Drive-Up Convenience \n\n Most 10x20 [drive-up storage units](https://www.sparefoot.com/blog/drive-up-storage-units) feature wide doors and ground-level access, making loading and unloading large items simple and efficient.',
			},
		],
	},
};
const twoPanelBlock1 = {
	props: {
		title: 'What Factors Affect 10x20 Storage Unit Costs?',
		suffix: '[Choosing the right storage unit for your needs](https://www.sparefoot.com/blog/tips-for-choosing-a-self-storage-facility) involves more than just measurements. Let’s talk about some of the factors that inform storage unit pricing so you can get the best deal on storage in your area.',
		type: 'two-panel',
		content: [
			{
				image: map,
				description:
					'### Location \n\n - City vs. rural pricing (urban costs 30-50% more) \n - High-demand areas see seasonal fluctuations \n - Proximity to major highways or city centers \n',
			},
			{
				image: electricity,
				description:
					'### Amenities \n\n - **Climate control:** Adds $30-70/month but protects valuable items \n - **10x20 drive-up storage units:** Usually cost more than indoor units \n - **Security features:** Advanced systems like livestream security footage may increase costs 10-15%',
			},
		],
	},
};
const reviews = [
	{
		reviewTitle: 'One phone call was all that was needed!',
		link: 'https://www.trustpilot.com/reviews/6876983ecc24807789b58726',
		reviewRating: 5,
		reviewText:
			'One phone call was all that was needed. I spoke with a SpareFoot representative who took care of my needs in the most efficient manner. The process was quick and smooth.',
		reviewerName: ' Robert,',
		reviewerInitials: 'R',
		reviewDate: '',
	},
	{
		reviewTitle: 'Easy to Use Website',
		link: 'https://www.trustpilot.com/reviews/6873aee374abbc40cb6c61b2',
		reviewRating: 5,
		reviewText:
			'I went to SpareFoot and typed in what I was looking for, and a number of storage places popped up. The best part is that I can make a reservation on this site without a credit card. That made the experience doable.',
		reviewerName: 'Colorado Customer',
		reviewerInitials: 'CC',
		reviewDate: '',
	},
	{
		reviewTitle: 'Happy SpareFoot customer.',
		link: 'https://www.trustpilot.com/reviews/68723bddfb697cca721e2f7d',
		reviewRating: 5,
		reviewText:
			'The whole experience was very positive; a lot was handled online, which made it easier.',
		reviewerName: 'Mary Luster',
		reviewerInitials: 'ML',
		reviewDate: '',
	},
	{
		reviewTitle: 'Very easy to make a storage reservation.',
		link: 'https://www.trustpilot.com/reviews/686a97156b4484710eb5a7cc',
		reviewRating: 5,
		reviewText:
			'Very easy to make a reservation. Took less than a minute. Love it!',
		reviewerName: 'Kevin Tate',
		reviewerInitials: 'KT',
		reviewDate: '',
	},
];

const Faqs = [
	{
		question: 'Can I park my car in a 10x20 storage unit?',
		answer: "You can park a car in a 10x20 storage unit. The best part is, if your car is a sedan or mid-sized SUV, you’ll even have extra room in your storage unit for accessories and additional boxes. 200 square feet easily accommodates cars up to 20 feet long, including most SUVs, pickup trucks, and even some small RVs. You'll typically have 8-10 feet of remaining space for boxes, furniture, seasonal items, or equipment.",
	},
	{
		question: 'How much furniture can fit in a 10x20 storage unit?',
		answer: "A 10x20 storage unit can hold the contents of a 3-4 bedroom home. With 1,600-2,000 cubic feet of space, you can fit multiple bedroom sets, living room furniture, kitchen appliances, dining room pieces, and 60+ boxes. That's roughly double what fits in a 10x10 unit and 33% more than a 10x15.",
	},
	{
		question:
			"What's the difference between 10x20 climate-controlled and standard units?",
		answer: 'A 10x20 climate-controlled unit maintains consistent temperature (55-85°F) and humidity levels (30-50%). Standard units fluctuate with outdoor conditions. This protection is crucial for the large quantities of items typically stored in these spacious units. Without climate control, electronics, wooden furniture, documents, clothing, and artwork can suffer damage from extreme temperatures, moisture, and humidity changes.',
	},
	{
		question:
			'Are cheap 10x20 storage units worth it, or should I pay more for premium features?',
		answer: "Finding cheap 10x20 storage units can offer great value, but it's important to understand what you're getting. Budget-friendly options often mean basic security, limited access hours, older facilities, or less convenient locations. However, if you're storing items that aren't extremely valuable or sensitive, and you don't need frequent access, these units can save you significant money, sometimes $50-100+ per month.",
	},
	{
		question:
			'Should I choose a 10x20 indoor storage unit or a drive-up option?',
		answer: "The choice between a 10x20 indoor storage unit and a drive-up option depends on your access needs and what you're storing. Drive-up units offer unbeatable convenience - you can back a truck or trailer right up to your door, making loading and unloading heavy furniture, appliances, or vehicles much easier. They're perfect for frequent access, business inventory, or bulky items that are difficult to carry long distances.",
	},
];

const pageType = 'SGP';

export const TenByTwentyContent = {
	type: '10x20',
	pageType: pageTypes.SGP,
	sections: [
		{
			title: '10x20 Storage Hero',
			background: 'yellow',
			modules: [
				{
					type: 'hero',
					id: 'sgp-hero',
					background: 'yellow',
					props: {
						content: {
							pageType,
							title: "10x20 Storage Units: Large Units for Life's Biggest Storage Challenges",
							description:
								"Storing an entire house? Multiple vehicles? Running a growing business? A 10x20 storage unit gives you the room to breathe with 200 square feet of spacious storage. Whether you're relocating across the country, downsizing to a smaller home, or need secure space for inventory and equipment, these large units handle it all. Find cheap 10x20 storage units near you to quickly solve your biggest space problems.",
							image: Hero,
							inputLabel: 'Find Your Ideal 10x20 Storage Unit',
							CTAText: 'Find 10x20 Storage Now',
						},
					},
				},
			],
		},

		{
			title: 'nearby units',
			background: 'gray',
			modules: [
				{
					type: 'facilitiesNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},

		{
			title: 'Alternate Content Section 1',
			noPaddingBottom: true,
			modules: [
				{
					type: 'alternatingContent',
					id: 'alternatContent1',
					props: {
						props: alternateContentData1,
					},
				},
			],
		},

		{
			title: 'Three Panel Block',
			background: 'gray',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'threePanelBlock',
					props: threePanelBlock,
				},
			],
		},

		{
			title: 'Two Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock',
					props: twoPanelBlock,
				},
			],
		},

		{
			title: 'SGP size chart',
			background: 'gray',
			pageType: pageTypes.SGP,
			modules: [
				{
					type: 'sizeChart',
					slug: 'size-chart-section',
					props: {
						title: '10x20 Storage Unit Size Guide: Understanding Your Space',
						image: twoColumnTableImage,
						description:
							"A 10x20 storage unit provides 200 square feet of floor space and typically 1,600-2,000 cubic feet of total storage space. \n\n Here's how big a 10x20 storage unit is.",
						pageType: pageTypes.SGP,
						tableType: 'specialType',
						headers: [
							{
								label: 'Dimension',
								key: 'Dimension',
							},
							{
								label: '10x20 Storage Unit',
								key: 'Unit',
							},
						],
						rows: [
							{
								Dimension: 'Floor Space',
								Unit: '200 sq ft',
							},
							{
								Dimension: 'Cubic Feet',
								Unit: '1,600-2,000 cu ft',
							},
							{
								Dimension: 'Real-World Size',
								Unit: 'About the size of a standard one-car garage',
							},
							{
								Dimension: 'Ceiling Height',
								Unit: 'Typically 8-10 feet',
							},
							{
								Dimension: 'Door Width',
								Unit: 'Usually 8-10 feet wide',
							},
						],
					},
				},
			],
		},
		{
			title: 'Three Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'threePanelBlock1',
					props: threePanelBlock1,
				},
			],
		},
		{
			title: '10x20 Storage Unit Cost Breakdown',
			pageType: pageTypes.SGP,
			background: 'gray',
			modules: [
				{
					type: 'sizeChart',
					id: '10x30-cost-breakdown-table-section',
					props: {
						pageType: pageTypes.SGP,
						title: '10x20 Storage Unit Cost Breakdown',
						image: threeColumnTableImage,
						description:
							'Understanding the average cost of a 10x20 storage unit helps you budget effectively and find the best deals:',
						slug: 'size-chart-section',
						headers: [
							{
								label: 'Location Type',
								key: 'Location Type',
							},
							{
								label: 'Standard Unit',
								key: 'Standard Unit',
							},
							{
								label: 'Climate Controlled',
								key: 'Climate Controlled',
							},
							{
								label: 'Drive-Up Access',
								key: 'Drive-Up Access',
							},
						],
						rows: [
							{
								'Location Type': 'Cities',
								'Standard Unit': '$120 - $300',
								'Climate Controlled': '$150 - $350',
								'Drive-Up Access': '$130 - $320',
							},
							{
								'Location Type': 'Suburban Areas',
								'Standard Unit': '$90 - $220',
								'Climate Controlled': '$120 - $270',
								'Drive-Up Access': '$100 - $240',
							},
							{
								'Location Type': 'Rural Areas',
								'Standard Unit': '$70 - $180',
								'Climate Controlled': '$100 - $230',
								'Drive-Up Access': '$80 - $200',
							},
						],
					},
				},
			],
		},

		{
			title: 'Two Panel Block',
			modules: [
				{
					type: 'cardBlockContent',
					id: 'twoPanelBlock1',
					props: twoPanelBlock1,
				},
			],
		},

		{
			title: 'Reviews Section',
			background: 'dark',
			modules: [
				{
					type: 'reviews',
					props: {
						pageType: pageTypes.SGP,
						reviews,
						title: 'Why Others Choose SpareFoot to Find 10x20 Storage Units',
					},
				},
			],
		},
		{
			title: 'FAQ Section',
			background: 'gray',
			modules: [
				{
					type: 'faqs',
					props: {
						header: '10x20 Storage Unit Size FAQs',
						faqs: Faqs,
					},
				},
			],
		},
		{
			title: 'featured content',
			modules: [
				{
					type: 'featuredContent',
					props: {
						pageType: pageTypes.SGP,
						title: 'Learn More About Storage Unit Size Options',
						contentCards: [
							{
								title: 'General Storage Advice',
								date: 'August 7, 2025',
								image: shutterStock,
								link: 'https://www.sparefoot.com/blog/how-to-pick-the-right-size-storage-unit',
								content:
									'How to Pick the Right Size Self Storage Unit',
							},
							{
								title: 'General Storage Advice',
								date: 'October 29, 2025',
								image: largestStorage,
								link: 'https://www.sparefoot.com/blog/10x20-storage-unit-size-guide',
								content:
									'What Can You Fit Inside of a 10x20 Storage Unit?',
							},
							{
								title: 'Self Storage',
								date: 'October 17, 2025 ',
								image: postCovers,
								link: 'https://www.sparefoot.com/blog/largest-storage-unit-size-uses',
								content:
									'5 Ways to Use the Largest Storage Unit Size',
							},
							{
								title: 'How to Store It',
								date: 'October 22, 2025',
								image: carStorage,
								link: 'https://www.sparefoot.com/blog/car-storage-size-guide',
								content:
									'How to Pick the Right Size Storage Unit for Your Car',
							},
						],
					},
				},
			],
		},
		{
			title: 'More Ways to Store',
			background: 'gray',
			modules: [
				{
					type: 'links',
					props: {
						title: 'More Ways to Store',
						pageType: pageTypes.SGP,
						cards: ['ClimateControl', 'Car', '10x25', '10x30'],
					},
				},
			],
		},
		{
			title: 'nearby units',
			noPaddingBottom: true,
			modules: [
				{
					type: 'storageNearYou',
					props: {
						title: 'Popular Facilities Near',
					},
				},
			],
		},
	],
};
